import { CommaSeparatedLinks } from '~/components/comma-separated-links';
import { EventName } from '~/utils/logger';

export const ContractLink = ({
  contractKeys,
  contractsMap,
}: {
  contractKeys: string[];
  contractsMap: Record<string, any>;
}) => {
  const contractsList = contractKeys.map(key => contractsMap[key]);
  const hasAllContracts = contractsList.every(
    contract => contract !== undefined && contract !== null,
  );
  if (!hasAllContracts) return null;
  return (
    // Reached only via PerchGeneralTermsAndConsent on create-account. (SUBEXP-3193)
    <CommaSeparatedLinks
      lastConjunction=" and the "
      contracts={contractsList}
      linkProps={{ color: 'secondary' }}
      utilityAccountId={undefined}
      showPersonalizedContractPreview={false}
      screen={EventName.UserScreen}
    />
  );
};
